<template>
  <div class="channel">
    <div class="manage">
      <div class="big-title">
        <p>渠道风控</p>
      </div>
      <div class="middle-title">人脸识别系统</div>
      <div class="small-title">
        <h2>价值意义</h2>
        <p>
          人脸识别判客规则和百度人脸识别技术有效结合，实现智能判断客户到访时间与渠道推荐时间的先后，得出是否飞单、洗客、截客结论。大大降低内单外飞风险和营销费用，以及后期人工核查成本！
        </p>
      </div>

      <div class="value">
        <p class="desc">
          {{ valueList[valueId].desc }}
        </p>
        <div class="value-box">
          <div
            class="value-item"
            :class="{ active: item.id == valueId }"
            v-for="item in valueList"
            :key="item.id"
            @touchstart="changeValue(item.id)"
          >
            <img :src="item.img" alt="" />
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>

      <div class="small-title">
        <h2>案场摄像头标准部署图</h2>
        <p>
          在大堂入口处、沙盘、区位图、景观连廊、样板间等处，摄像头自动无感抓拍客户人脸头像，储存至来访客户索引库。
        </p>
      </div>
      <div class="camera">
        <div class="swiper-container" ref="slider">
          <div class="swiper-wrapper tab-nav">
            <div
              class="swiper-slide nav-item"
              :class="{ active: cameraId == item.id }"
              v-for="item in cameraList"
              :key="'nav' + item.id"
              @touchstart="changeCamera(item.id)"
            >
              {{ item.title }}
            </div>
          </div>
        </div>

        <div class="pad-content">
          <div class="line-desc">
            <p class="txt-left">终端部署区域</p>
            <p class="txt-right">摄像头设备</p>
          </div>
          <div class="camera-box">
            <img src="../../static/images/product/m_pad.png" />
            <div
              v-for="(item, index) in cameraList"
              :key="'num' + item.id"
              @touchstart="changeCamera(item.id)"
            >
              <div
                class="screen-box"
                v-if="index == item.id"
                :class="{
                  'screen-one': index == 0,
                  'screen-two': index == 1,
                  'screen-three': index == 2,
                  'screen-four': index == 3,
                  'screen-five': index == 4,
                }"
              >
                <img v-if="item.id==cameraId" :src="item.activeImg" alt="" />
                <img v-else :src="item.screenImg" alt="" />

              </div>
            </div>
          </div>
        </div>

        <div class="swiper-container" ref="slider">
          <div class="swiper-wrapper tab-nav">
            <div
              class="swiper-slide content-item"
              :class="{ active: cameraId == item.id }"
              v-for="item in cameraList"
              :key="'content' + item.id"
            >
              <img :src="item.viewImg" alt="" />
              <p>{{ item.desc }}</p>
            </div>
          </div>
        </div>

        <div class="card-box">
          <div
            class="card-item"
            v-for="item in discernList"
            :key="'discern' + item.id"
            @touchstart="changeDiscern(item.id)"
          >
            <div class="card-top" :class="{active:cardId==item.id}">
              <div class="btn">{{ item.icon }}</div>
              <h2>{{ item.title }}</h2>
              <p>{{ item.desc }}</p>
            </div>
            <div
              class="card-ct"
              :class="{ mar: cardId == 1 }"
              v-show="cardId == item.id"
            >
              <div class="type">{{ item.type }}</div>
              <div class="line" v-for="s_item in item.list" :key="s_item.id">
                <img :src="s_item.img" alt="" />
                <div class="right">
                  <h2>{{ s_item.title }}</h2>
                  <p>{{ s_item.desc }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="middle-title">应用场景及业务流程</div>
      <div class="view">
        <div
          class="view-item"
          v-for="(item, index) in viewList"
          :key="'view' + item.id"
          v-show="index < 4"
        >
          <img :src="item.img" alt="" />
          <div class="view-right">
            <h2>{{ item.title }}</h2>
            <p>
              {{ item.desc }}
            </p>
          </div>
        </div>
      </div>
      <div class="small-title">
        <h2>渠道管理</h2>
        <p>移动销售：智慧移动、高效跟客，随时随地掌控案场</p>
      </div>

      <div class="rotation">
        <img src="../../static/images/product/yuanxing.png" alt="" />
        <div
          class="rotation-item"
          v-for="item in bottomList"
          :key="'btn' + item.id"
        >
          <img :src="item.img" alt="" />
          <span>{{ item.desc }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  data() {
    return {
      navSwiper: "",
      cardId: 0,
      valueId: 0,
      cameraId: 0,
      valueList: [
        {
          id: 0,
          desc: "以线下人脸数据为基础，对客流统计、属性统计、轨迹统计进行采集",
          title: "智能化数据采集",
          img: require("../../static/images/product/mean_one.png"),
        },
        {
          id: 1,
          desc: "以购房客户为核心，打通融合各类系统数据",
          title: "多维数据整合",
          img: require("../../static/images/product/mean_two.png"),
        },
        {
          id: 2,
          desc: "用户画像（客户标签化、画像模型）",
          title: "AI智能分析",
          img: require("../../static/images/product/mean_three.png"),
        },
        {
          id: 3,
          desc: "推进由业务处理型向营销服务型转变，提升营销，营销氛围营造",
          title: "全面提高案场核心价值",
          img: require("../../static/images/product/mean_four.png"),
        },
        {
          id: 4,
          desc: "增强用户体验度：人脸识别、无感判断",
          title: "新型人脸识别技术",
          img: require("../../static/images/product/mean_five.png"),
        },
      ],
      viewList: [
        {
          id: 0,
          title: "渠道报备",
          desc:
            "宣传获客，提升到访转化；裂变拓客，打造经纪人圈层;快速报备，减少操作失误；高效发佣；提高带客积极性。",
          img: require("../../static/images/product/process1.png"),
        },
        {
          id: 1,
          title: "精准判客",
          desc:
            "客户到达案场，人脸识别系统自动识别客户的伴随人员，从而判断客户属性，快速识别客户有内场销售提供精准一对一服务。",
          img: require("../../static/images/product/process2.png"),
        },
        {
          id: 2,
          title: "来访登记",
          desc:
            "客户到达案场，由判客岗/内场销售接待并进行内场登记，安排跟进销售。",
          img: require("../../static/images/product/process3.png"),
        },
        {
          id: 3,
          title: "渠道带看确认",
          desc: "若有中介带看，可在平板端完成渠道带看确认。",
          img: require("../../static/images/product/process4.png"),
        },
        {
          id: 4,
          title: "无感抓拍",
          desc:
            "在大堂入门处/沙盘/区位图/样板间等处，摄像头自动无感抓拍客户人脸头像，储存至到访客户索引库。",
          img: require("../../static/images/product/process5.png"),
        },
        {
          id: 5,
          title: "提交验证",
          desc:
            "客户签约时，需提供身份证供扫描存档（抓取真实姓名/身份证号/身份证头像等信息）录入客户成交信息库。",
          img: require("../../static/images/product/process6.png"),
        },
        {
          id: 6,
          title: "渠道风险把控",
          desc:
            "监管人员根据风控报警，或巡查分析成交客户与来访客户人脸识别结果，结合业务流水综合判断，得出是否飞单/洗客/截客等结论。",
          img: require("../../static/images/product/process7.png"),
        },
        {
          id: 7,
          title: "案场客流统计",
          desc:
            "精确统计所有进场客户，对其进行各维度统计分析，提供精准的运营数据作决策分析。",
          img: require("../../static/images/product/process8.png"),
        },
      ],
      bottomList: [
        {
          id: 0,
          img: require("../../static/images/product/page.png"),
          desc: "① 60秒轻松录完一个客户",
        },
        {
          id: 1,
          img: require("../../static/images/product/page.png"),
          desc: "② 成交、回款轻松看：案场实时洞察，让售楼管理更高效",
        },
        {
          id: 2,
          img: require("../../static/images/product/page.png"),
          desc:
            "③ 多个角色全面掌控案场：驻场人员、判客人员、内场销售、场外销售、营销总等",
        },
        {
          id: 3,
          img: require("../../static/images/product/page.png"),
          desc: "④ 一个数据库，信息同步不滞后",
        },
      ],
      cameraList: [
        {
          id: 0,
          title: "1.样板间",
          desc: "样板间",
          viewImg: require("../../static/images/product/view.png"),
          screenImg: require("../../static/images/product/one_screen.png"),
          activeImg: require("../../static/images/product/one_screen_active.png"),
        },
        {
          id: 1,
          title: "2.洽谈区",
          desc: "洽谈区",
          viewImg: require("../../static/images/product/view.png"),
          screenImg: require("../../static/images/product/two_screen.png"),
          activeImg: require("../../static/images/product/two_screen_active.png"),
        },
        {
          id: 2,
          title: "3.景观连廊",
          desc: "景观连廊",
          viewImg: require("../../static/images/product/view.png"),
          screenImg: require("../../static/images/product/three_screen.png"),
          activeImg: require("../../static/images/product/three_screen_active.png"),
        },
        {
          id: 3,
          num: 4,
          title: "4.样板间",
          desc: "样板间",
          viewImg: require("../../static/images/product/view.png"),
          screenImg: require("../../static/images/product/four_screen.png"),
          activeImg: require("../../static/images/product/four_screen_active.png"),
        },
        {
          id: 4,
          num: 5,
          title: "5.营销中心大门",
          desc: "营销中心大门",
          viewImg: require("../../static/images/product/view.png"),
          screenImg: require("../../static/images/product/five_screen.png"),
          activeImg: require("../../static/images/product/five_screen_active.png"),
        },
      ],
      discernList: [
        {
          id: 0,
          icon: "客户来访",
          title: "人脸摄像头设备",
          desc: "抓拍来访客户头像",
          type: "人脸识别算法",
          list: [
            {
              id: 0,
              img: require("../../static/images/product/face1.png"),
              title: "人脸检测",
              desc: "检测人脸位置，锁定人脸坐标",
            },
            {
              id: 1,
              img: require("../../static/images/product/face2.png"),
              title: "人脸跟踪",
              desc: "精准定位人脸，持续跟踪面部",
            },
            {
              id: 2,
              img: require("../../static/images/product/face3.png"),
              title: "人脸对比",
              desc: "对比相似度，返回置信度可调节阈值",
            },
            {
              id: 3,
              img: require("../../static/images/product/face4.png"),
              title: "人脸属性",
              desc: "检测人脸性别、年龄等属性特征",
            },
            {
              id: 4,
              img: require("../../static/images/product/face5.png"),
              title: "人脸查找",
              desc: "基于人脸图像或视频、与注册库比对查找",
            },
            {
              id: 5,
              img: require("../../static/images/product/face6.png"),
              title: "活体检测",
              desc: "支持RGB/IR活体检测，预防恶意攻击",
            },
          ],
        },
        {
          id: 1,
          icon: "客户成交",
          title: "认证检验算法",
          desc: "核验成交客户身份",
          type: "认证检验算法",
          list: [
            {
              id: 0,
              img: require("../../static/images/product/check1.png"),
              title: "身份证信息读取",
              desc:
                "身份证读卡器可快速、精确地读取身份证芯片里的真实姓名/身份证号/身份证头像等信息",
            },
            {
              id: 1,
              img: require("../../static/images/product/check2.png"),
              title: "真人检测",
              desc:
                "根据客户对机器随机提出动作指令的响应情况，检测是否真人操作",
            },
            {
              id: 2,
              img: require("../../static/images/product/check3.png"),
              title: "人脸检测与比对",
              desc:
                "现场抓取人脸图像、检测、提取人脸生物特征与读取的身份证头像进行比对",
            },
          ],
        },
      ],
    };
  },
  methods: {
    changeValue(id) {
      if (this.valueId != id) {
        this.valueId = id;
      }
    },
    changeCamera(id) {
      if (this.cameraId != id) {
        this.cameraId = id;
      }
    },
    changeDiscern(id){
      if(this.cardId !=id){
        this.cardId = id;
      }
    }
  },
  mounted() {
    this.navSwiper = new Swiper(".swiper-container", {
      slidesPerView: 2.5,
      loop: false,
    });
  },
};
</script>

<style lang="stylus" scoped>
.camera {
  .card-box {
    display: flex;
    margin-top: 38px;
    width: 351px;
    height: 420px;
    background: #FFFFFF;
    border: 1px solid #E8E8E8;

    .card-top {
      position: relative;
      width: 174px;
      height: 66px;
      background: #F8F8F8;
      text-align: center;

      .btn {
        position: absolute;
        top: -5px;
        left: 60px;
        margin: 0 auto;
        text-align: center;
        line-height: 16px;
        width: 55px;
        height: 16px;
        background: #999999;
        font-size: 11px;
        font-weight: 500;
        color: #fff;
      }

      h2 {
        padding-top: 18px;
        font-size: 12px;
        font-weight: 800;
        color:#999999;
      }

      p {
        font-size: 11px;
        font-weight: 400;
        color: #999999;
      }
    }
    .card-top.active{
      background:#fff;

      .btn{
        color: #333333;
        background: #EDB50B;
      }
      h2 {
        color: #333333;
      }
    }

    .card-ct.mar {
      left: 20px;
    }

    .card-ct {
      position: absolute;
      margin-right: 10px;

      .type {
        font-size: 12px;
        font-weight: 800;
        color: #333333;
        margin-left: 10px;
        margin-top: 20px;
      }

      .type:before {
        content: '';
        position: absolute;
        width: 2px;
        height: 11px;
        background: #EDB50B;
        left: 4px;
      }

      .line {
        display: flex;
        align-items: center;
        margin-left: 16px;
        margin-top: 14px;

        img {
          width: 36px;
          height: 36px;
        }

        h2 {
          font-size: 11px;
          font-weight: 800;
          color: #333333;
        }

        p {
          font-size: 11px;
          font-weight: 500;
          color: #666666;
          line-height: 14px;
        }

        .right {
          margin-left: 8px;
        }
      }
    }
  }

  .tab-nav {
    display: flex;
    margin-top: 27px;
  }

  .content-item {
    width: 140px;
    height: 100px;
    background: #92929C;
    text-align: center;
    font-size: 9px;
    font-weight: 500;
    color: #FFFFFF;
    margin-right: 2px;

    img {
      width: 125px;
      margin-top: 3px;
    }

    p {
      margin-top: 4px;
    }
  }
  .content-item.active{
    background:#EDB50B;
  }

  .nav-item {
    text-align: center;
    font-size: 11px;
    font-weight: 500;
    color: #666666;
    line-height: 35px;
    min-width: 91px;
    height: 35px;
    background: #FFFFFF;
    border: 1px solid #E8E8E8;
  }

  .nav-item.active {
    color: #333333;
    font-weight: 800;
  }

  .line-desc {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;

    .txt-left {
      font-size: 8px;
      font-weight: 500;
      color: #333333;
      margin-left: 28px;
    }

    .txt-right {
      position: relative;
      font-size: 8px;
      font-weight: 400;
      color: #666666;
    }

    .txt-right:before {
      content: '';
      position: absolute;
      left: -10px;
      top: 4px;
      width: 6px;
      height: 6px;
      background: #35F6FF;
      border-radius: 50%;
    }
  }

  .camera-box {
    position: relative;
    margin-top: 5px;
  }

  .screen-box {
    img {
      position: absolute;
    }
  }

  .screen-one {
    position: absolute;
    top: 125px;
    left: 35px;
    width: 22px;
    height: 31px;
  }

  .screen-two {
    position: absolute;
    top: 130px;
    left: 141px;
    width: 30px;
    height: 22px;
  }

  .screen-three {
    position: absolute;
    top: 71px;
    left: 161px;
    width: 22px;
    height: 31px;
  }

  .screen-four {
    position: absolute;
    top: 168px;
    left: 256px;
    width: 30px;
    height: 22px;
  }

  .screen-five {
    position: absolute;
    top: 162px;
    left: 113px;
    width: 22px;
    height: 31px;
  }
}

.big-title {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 25px;

  p {
    font-size: 19px;
    font-weight: bold;
    color: #333333;
  }
}

.manage {
  width: 345px;
  margin: 0 auto;
}

.middle-title {
  font-size: 16px;
  font-weight: 800;
  color: #333333;
  margin-top: 19px;
  margin-bottom: 23px;
}

.small-title {
  h2 {
    font-size: 16px;
    font-weight: 800;
    color: #333333;
    margin-bottom: 5px;
  }

  p {
    font-size: 12px;
    font-weight: 500;
    color: #7E8592;
    line-height: 17px;
  }
}

.channel {
  padding-top: 47px;
}

.value {
  margin-top: 25px;
  width: 351px;
  height: 290px;
  background: #FFFFFF;
  border: 1px solid #E1E6F0;
  padding: 39px 0 39px;
  box-sizing: border-box;
  margin-bottom: 25px;

  p.desc {
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    line-height: 28px;
    padding: 0 29px;
  }

  .value-box {
    display: flex;
    flex-wrap: wrap;
    margin-left: 7px;
    margin-top: 43px;
  }

  .value-item {
    line-height: 43px;
    width: 169px;
    height: 43px;
    background: #FFFFFF;
    border: 1px solid #DEDEDE;
    padding-left: 13px;

    img {
      width: 20px;
      height: 20px;
    }

    span {
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      line-height: 14px;
      padding-left: 7px;
    }
  }

  .value-item:nth-child(1), .value-item:nth-child(2), .value-item:nth-child(3) {
    border-bottom: 0;
  }

  .value-item:nth-child(2), .value-item:nth-child(4) {
    border-left: 0;
  }

  .value-item.active {
    position: relative;
    border: 1px solid #FFC000;
  }

  .value-item.active::before {
    content: '';
    position: absolute;
    width: 3px;
    height: 41px;
    background: #FFC000;
    left: 0px;
  }
}

.view {
  box-sizing: border-box;
  padding: 20px 15px;
  width: 351px;
  height: 339px;
  background: #FFFFFF;
  border: 1px solid #E8E8E8;
  margin-bottom: 42px;

  .view-item {
    display: flex;
    margin-bottom: 20px;

    img {
      width: 30px;
      height: 30px;
    }

    .view-right {
      margin-left: 7px;

      h2 {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        line-height: 14px;
      }

      p {
        margin-top: 7px;
        font-size: 12px;
        font-weight: 500;
        color: #575D6C;
        line-height: 14px;
        text-align: justify;
      }
    }
  }
}

.rotation {
  padding-top: 41px;
  margin-bottom: 50px;

  .rotation-item {
    display: flex;
    align-items: center;
    margin-top: 40px;

    img {
      width: 30px;
      height: 30px;
    }

    span {
      margin-left: 12px;
      font-size: 12px;
      font-weight: 500;
      color: #333333;
      line-height: 15px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/WisdomChannel.vue